// extracted by mini-css-extract-plugin
export default {"parentTitle":"screenList_parentTitle__iGIbE","parentDescription":"screenList_parentDescription__syUSO","parentDocuments":"screenList_parentDocuments__a6ocT"};